import { getCollectionApi } from "dbApi";
import firebaseUtil from "firebaseUtil";
import { flog, flogError } from "util/FileLogger";

export function saveCustomFormObject(customForm, obj, resolve, reject) {
    obj.userLastChange = firebaseUtil.getCurrentUser().uid
    obj.dataLastChange = firebaseUtil.firestore().FieldValue.serverTimestamp()
    obj.dataLastChangeStr = dateToString(new Date());
    obj.salvoOffline = true;//server change on recive

    let refColl = getColDataCustomForm(customForm)
    const { uid } = obj;
    let docSalvar = null;
    if (uid) {
        docSalvar = refColl.doc(uid);
    } else {
        docSalvar = refColl.doc();
        obj.uid = docSalvar.id;
    }
    let temquedarretorno = false
    let observer = docSalvar.onSnapshot(function (doc) {
        //SNAMP PARA RETORNO offline
        if (observer) observer()
        if (!doc.exists) {
            // console.log("Salvou item original- doc nao exite: ", itemOriginal.uid);

        } else {
            if (resolve) {
                temquedarretorno = false
                resolve({ obj: { ...doc.data() }, salvoOffline: true })
            }
        }
    })
    docSalvar.set(obj, { merge: true })
        .then(() => {
            if (observer) observer()
            console.log('online save form,obj: ', customForm.uid, obj.uid)
            flog("Salvando objeto... " + customForm.uid + obj.uid)
            if (temquedarretorno) {
                resolve({ obj, docSalvar });
            }
        })
        .catch((error) => {
            console.log("error saveCustomFormObject", error);
            flogError(`Erro ao salvar o objeto... Descrição do erro: ${error}`)
            reject(error)
        });
    setTimeout(() => {
        console.log('mata observer por timeout saveoffline')
        if (observer) observer()
    }, 2000);
}


export function getColCustomForms() {
    return getCollectionApi('CustomForm');
}


export function getColDataCustomForm(form) {
    let str = 'ValueCustomForm/' + form.uid + "/Values"
    return getCollectionApi(str);
}

function dateToString(data) {

    if (!data) {
        return "";
    }
    if (typeof data === 'string') {
        data = new Date(data)
    }

    try {
        data.getMinutes()
    } catch (error) {
        data = new Date(data.seconds * 1000)
    }


    try {


        var mm = data.getMonth() + 1; // getMonth() is zero-based
        var dd = data.getDate();
        var minutes = data.getMinutes();
        var hour = data.getHours();


        return [
            (dd > 9 ? '' : '0') + dd,
            (mm > 9 ? '' : '0') + mm,
            data.getFullYear(),
        ].join('/') + " " + (hour > 9 ? '' : '0') + hour + ":" + (minutes > 9 ? '' : '0') + minutes;
    } catch (error) {

        console.log('error', error);
        console.log('data', data);

        return "erro"

    }
}
